if (!customElements.get('zc-faq-root')) {
  customElements.define('zc-faq-root', class extends HTMLElement {});
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-zc-faq]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-category]')];
    const items = [...root.querySelectorAll('[data-faq-item]')];
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const category = tab.dataset.category;
      tabs.forEach((button) => { const active = button === tab; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', active); });
      root.querySelectorAll('[data-faq-group]').forEach((group) => {
        group.hidden = category !== 'all' && group.dataset.faqGroup !== category;
      });
    }));
    items.forEach((item) => item.addEventListener('toggle', () => { if (item.open) items.forEach((other) => { if (other !== item) other.open = false; }); }));
  });
});
